import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Icon } from '~/components'

import { toggleArticleBookmark, toggleArticleFlare } from '~/actions/article'

import { Timestamps } from '~/services'


class Post extends React.Component {

    static propTypes = {
		bookmarks: PropTypes.array.isRequired,
		bookmarked: PropTypes.string,
		date: PropTypes.string.isRequired,
		flares: PropTypes.array.isRequired,
		flared: PropTypes.string,
		images: PropTypes.object.isRequired,
		ID: PropTypes.number,
		interests: PropTypes.array,
		read_time: PropTypes.number,
		post_type: PropTypes.object.isRequired,
		title: PropTypes.string.isRequired,
	};

    constructor(props) {
    	super(props);
    	this.state = {
            bookmarked: !!props.bookmarked,
            flared: !!props.flared
        };
	};

    bookmark = () => {
		this.props.toggleArticleBookmark(this.props.ID)
		this.setState({
			bookmarked: !this.state.bookmarked
		})
	};

    flare = () => {
		this.props.toggleArticleFlare(this.props.ID)
		this.setState({
			flared: !this.state.flared
		})
	};

    render() {

		return (
			<Link to={this.props.link} state={{article: this.props}} className="no-style">
                <div className="post-preview__img">
                    <img src={this.props.images.banner} alt={this.props.title} />

                    { this.props.sessionsAllowed && this.props.loggedIn &&
						<div className="hover-icons">
								<span className={"clickable hover-icon " + (this.state.bookmarked ? 'bookmarked' : '')} onClick={this.bookmark}>
									<Icon icon='bookmarks' className={ this.state.bookmarked ? 'text-light-success' : 'text-mid-gray' } />
								</span>
						</div>
                    }
                </div>

				<footer className="post-preview__content">

					<h5 className="text-center" style={{textTransform: 'capitalize'}}>{this.props.post_type.singular_lower}</h5>

					<h3 className="mtop0 mbot15">{this.props.title}</h3>

					<p className="small details text-dark-gray text-center">
						{'Posted ' + Timestamps.timeSince(this.props.date, true)} | {this.props.read_time + ' min read'}
					</p>

				</footer>
			</Link>
		)
		
	}
}

const mapStateToProps = state => ({
	loggedIn: 'ID' in state.session.user,
	sessionsAllowed: state.session.sessionsAllowed
})

const mapDispatchToProps = dispatch => bindActionCreators({ toggleArticleBookmark, toggleArticleFlare }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Post );



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Filtered/components/Post.js